// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { BannerDTO } from "../io/hyperify/core/banner/types/BannerDTO";
import { QueryParamUtils } from "../io/hyperify/core/QueryParamUtils";
import { parseNonEmptyString } from "../io/hyperify/core/types/String";

/**
 * Production: https://geoip.sendanor.fi/lookup
 */
export const GEOIP_BACKEND_URL = parseNonEmptyString(process.env.REACT_APP_GEOIP_URL) ?? 'http://localhost:3000/geoip';

/**
 * Production: https://www.6b.fi/api/banner
 */
export const API_URL = parseNonEmptyString(process.env.REACT_APP_API_URL) ?? 'http://localhost:3000/api';

/**
 * Production: https://www.6b.fi/api/banner
 */
export const BANNER_BACKEND_URL = parseNonEmptyString(process.env.REACT_APP_BANNER_URL) ?? `${API_URL}/banner`;

/**
 * Production: https://www.6b.fi/api/banner
 */
export const BANNER_CLICK_URL = parseNonEmptyString(process.env.REACT_APP_BANNER_CLICK_URL) ?? `${API_URL}/click`;

/**
 * Production: https://www.6b.fi/api/click?b=BANNER_ID
 */
export const GET_BANNER_CLICK_URL = (banner: BannerDTO, referrer: string) : string => `${BANNER_CLICK_URL}${QueryParamUtils.stringifyQueryParams({b: banner.id, ref: referrer})}`;
